<template>
  <TransitionRoot as="template" :show="open && programArticle !== undefined">
    <Dialog
      as="div"
      static
      class="fixed inset-0 z-[999] overflow-y-auto"
      @close="close"
      :open="open"
    >
      <div
        class="flex items-end justify-center min-h-screen mt-16 px-4 pt-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay
            class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
          />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-[0s]"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="inline-block md:p-10 md:pb-12 p-6 overflow-hidden text-left align-bottom transition-all transform bg-brand-gray-900 border border-brand-green shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          >
            <div class="absolute top-0 right-0 pt-6 pr-6">
              <button
                type="button"
                class="text-gray-400 transition-all duration-200 bg-brand-gray-900 rounded-md group hover:opacity-80 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="close"
              >
                <span class="sr-only">Close</span>
                <XIcon
                  class="w-6 h-6 duration-500 ease-in-out transform group-hover:scale-110"
                  aria-hidden="true"
                />
              </button>
            </div>
            <div class="sm:flex sm:items-start">
              <div class="mt-3 sm:mt-0">
                <article v-if="programArticle != null">
                  <div class="flex">
                    <img
                      class="w-[128px] h-[128px] object-cover object-top rounded-md mr-6"
                      :src="programArticle.speaker.photo_url"
                      :alt="programArticle.speaker.name"
                    />
                    <div>
                      <p class="font-semibold text-brand-green text-[14px] font-mono mb-3">
                        {{ programArticle.time }}
                      </p>
                      <p
                        class="
                          font-semibold
                          truncate
                          w-48
                          md:w-72
                          text-[20px]
                        "
                      >
                        {{ programArticle.speaker.name }}
                      </p>
                      <p class="text-body">
                        {{ programArticle.speaker.position }}
                      </p>

                      <div class="flex mt-4 space-x-4">
                        <!-- socky -->

                        <a
                          class="transition-all duration-200 group opacity-50 hover:opacity-100"
                          v-if="programArticle.speaker.web"
                          :href="programArticle.speaker.web"
                          target="_blank"
                        >
                          <svg
                            class="transition-all duration-200 transform group-hover:scale-110"
                            width="16"
                            height="16"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.7336 0.0666504C9.87863 0.0666504 9.07586 0.399884 8.47106 1.00415L7.40439 2.07082C6.80013 2.67562 6.46689 3.47838 6.46689 4.33332C6.46689 5.00759 6.67671 5.64744 7.06064 6.1854L6.18564 7.0604C5.64762 6.67665 5.00743 6.46665 4.33356 6.46665C3.47863 6.46665 2.67586 6.79988 2.07106 7.40415L1.00439 8.47082C0.400128 9.07562 0.0668945 9.87838 0.0668945 10.7333C0.0668945 11.5883 0.400128 12.391 1.00439 12.9958C1.60866 13.6006 2.41196 13.9333 3.26689 13.9333C4.12183 13.9333 4.92459 13.6001 5.52939 12.9958L6.59606 11.9292C7.20033 11.3244 7.53356 10.5216 7.53356 9.66665C7.53356 9.37278 7.49159 9.08613 7.41585 8.8104L6.45648 9.76978C6.43194 10.2812 6.23123 10.7851 5.84189 11.175L4.77523 12.2417C3.94323 13.0737 2.59003 13.0737 1.75856 12.2417C0.927094 11.4097 0.926561 10.0565 1.75856 9.22498L2.82523 8.15832C3.24123 7.74232 3.78794 7.5354 4.3346 7.5354C4.70888 7.5354 5.0795 7.63953 5.41169 7.83436L3.95648 9.28957C3.90529 9.33871 3.86443 9.39757 3.83627 9.46271C3.80812 9.52785 3.79325 9.59794 3.79253 9.6689C3.7918 9.73985 3.80525 9.81024 3.83207 9.87593C3.85889 9.94163 3.89855 10.0013 3.94872 10.0515C3.9989 10.1017 4.05858 10.1413 4.12428 10.1681C4.18997 10.195 4.26036 10.2084 4.33131 10.2077C4.40227 10.207 4.47237 10.1921 4.5375 10.1639C4.60264 10.1358 4.6615 10.0949 4.71064 10.0437L10.044 4.7104C10.121 4.63549 10.1737 4.53904 10.195 4.43369C10.2163 4.32835 10.2053 4.21903 10.1634 4.12005C10.1215 4.02107 10.0507 3.93705 9.96025 3.87901C9.86979 3.82097 9.76391 3.79161 9.65648 3.79478C9.51792 3.7989 9.38641 3.85681 9.28981 3.95623L7.8346 5.41144C7.35396 4.59378 7.4574 3.5257 8.15856 2.82498L9.22523 1.75832C9.64123 1.34232 10.1869 1.1354 10.7336 1.1354C11.2802 1.1354 11.8259 1.34285 12.2419 1.75832C13.0739 2.59032 13.0739 3.94352 12.2419 4.77498L11.1752 5.84165C10.7859 6.23098 10.2815 6.4317 9.77002 6.45623L8.81064 7.41561C9.08638 7.49134 9.37303 7.53332 9.66689 7.53332C10.5218 7.53332 11.3246 7.20008 11.9294 6.59582L12.9961 5.52915C13.6003 4.92435 13.9336 4.12158 13.9336 3.26665C13.9336 2.41172 13.6003 1.60895 12.9961 1.00415C12.3913 0.399884 11.5885 0.0666504 10.7336 0.0666504Z"
                              fill="#9EFC4E"
                            />
                          </svg>
                        </a>
                        <a
                          class="transition-all duration-200 group opacity-50 hover:opacity-100 hover:cursor-pointer"
                          v-if="programArticle.speaker.linkedin"
                          :href="programArticle.speaker.linkedin"
                          target="_blank"
                        >
                          <svg
                            class="transition-all duration-200 transform group-hover:scale-110"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.75 3C4.24011 3 3 4.24011 3 5.75V18.25C3 19.7599 4.24011 21 5.75 21H18.25C19.7599 21 21 19.7599 21 18.25V5.75C21 4.24011 19.7599 3 18.25 3H5.75ZM5.75 4.5H18.25C18.9491 4.5 19.5 5.05089 19.5 5.75V18.25C19.5 18.9491 18.9491 19.5 18.25 19.5H5.75C5.05089 19.5 4.5 18.9491 4.5 18.25V5.75C4.5 5.05089 5.05089 4.5 5.75 4.5ZM7.75 6.5C7.41848 6.5 7.10054 6.6317 6.86612 6.86612C6.6317 7.10054 6.5 7.41848 6.5 7.75C6.5 8.08152 6.6317 8.39946 6.86612 8.63388C7.10054 8.8683 7.41848 9 7.75 9C8.08152 9 8.39946 8.8683 8.63388 8.63388C8.8683 8.39946 9 8.08152 9 7.75C9 7.41848 8.8683 7.10054 8.63388 6.86612C8.39946 6.6317 8.08152 6.5 7.75 6.5ZM7 10C6.7235 10 6.5 10.2235 6.5 10.5V17C6.5 17.2765 6.7235 17.5 7 17.5H8.5C8.7765 17.5 9 17.2765 9 17V10.5C9 10.2235 8.7765 10 8.5 10H7ZM10.5 10C10.2235 10 10 10.2235 10 10.5V17C10 17.2765 10.2235 17.5 10.5 17.5H12C12.2765 17.5 12.5 17.2765 12.5 17V13.25C12.5 12.5605 13.0605 12 13.75 12C14.4395 12 15 12.5605 15 13.25V17C15 17.2765 15.2235 17.5 15.5 17.5H17C17.2765 17.5 17.5 17.2765 17.5 17V13C17.5 11.3455 16.1545 10 14.5 10C13.731 10 13.0315 10.293 12.5 10.7705V10.5C12.5 10.2235 12.2765 10 12 10H10.5Z"
                              fill="#9EFC4E"
                            />
                          </svg>
                        </a>
                        <a
                          class="transition-all duration-200 group opacity-50 hover:opacity-100 hover:cursor-pointer"
                          v-if="programArticle.speaker.twitter"
                          :href="programArticle.speaker.twitter"
                          target="_blank"
                        >
                          <svg
                            class="transition-all duration-200 transform group-hover:scale-110"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.6668 2C8.8563 2 7.38699 3.46291 7.34776 5.26432C5.74702 5.07233 4.70464 4.47384 4.06521 3.88411C3.3561 3.23013 3.13162 2.64909 3.13162 2.64909C3.09884 2.56651 3.04466 2.49416 2.97465 2.43947C2.90464 2.38478 2.82132 2.34974 2.73326 2.33793C2.64521 2.32613 2.5556 2.338 2.47366 2.37232C2.39172 2.40664 2.32039 2.46217 2.26703 2.5332C2.26703 2.5332 1.66677 3.33333 1.66677 4.5C1.66677 5.167 1.87737 5.66052 2.12836 6.07878C2.11912 6.07445 2.05675 6.05273 2.05675 6.05273C1.97706 6.01295 1.88819 5.99517 1.79932 6.00123C1.71046 6.0073 1.62483 6.03699 1.55128 6.08723C1.47774 6.13748 1.41895 6.20646 1.381 6.28704C1.34304 6.36762 1.3273 6.45687 1.33539 6.54557C1.33539 6.54557 1.52784 7.95228 2.85037 8.98047L2.71235 9.01497C2.63743 9.03368 2.56785 9.06948 2.50909 9.11957C2.45032 9.16966 2.40395 9.23269 2.37361 9.3037C2.34328 9.37471 2.3298 9.45178 2.33424 9.52888C2.33868 9.60597 2.36091 9.68098 2.3992 9.74805C2.3992 9.74805 2.62346 10.1274 3.09321 10.5267C3.37172 10.7634 3.78086 11.0077 4.26313 11.2337C3.67086 11.4501 2.78771 11.6667 1.50011 11.6667C1.40402 11.6667 1.30997 11.6943 1.2292 11.7464C1.14844 11.7984 1.08437 11.8726 1.04467 11.9601C1.00498 12.0476 0.991329 12.1447 1.00536 12.2398C1.0194 12.3348 1.06052 12.4238 1.1238 12.4961C1.1238 12.4961 1.50588 12.917 2.26117 13.2832C3.01647 13.6494 4.17993 14 5.83344 14C8.74001 14 10.8283 12.6057 12.1316 10.8385C13.4349 9.07137 14.0001 6.9537 14.0001 5.33333C14.0001 5.23052 13.9937 5.12915 13.9845 5.02865C14.6882 4.35053 14.9523 3.84074 14.965 3.81576C15.0283 3.68876 15.0047 3.53623 14.9064 3.4349C14.8084 3.33323 14.6565 3.3046 14.5275 3.36393L14.4734 3.38867C14.4271 3.41001 14.3808 3.43147 14.3341 3.45247C14.4698 3.23614 14.5768 3.00496 14.6511 2.76562C14.6925 2.63363 14.6479 2.48898 14.5385 2.40365C14.4292 2.31831 14.2786 2.30918 14.1603 2.38151C13.7528 2.62912 13.3623 2.80246 12.9558 2.91862C12.3576 2.35116 11.5524 2 10.6668 2ZM10.6668 3C11.9612 3 13.0001 4.03894 13.0001 5.33333C13.0001 6.71296 12.482 8.67863 11.3269 10.2448C10.1719 11.811 8.42687 13 5.83344 13C4.57837 13 3.7435 12.773 3.11795 12.5273C3.77322 12.4256 4.33742 12.2898 4.74295 12.1328C5.44617 11.8606 5.82563 11.5462 5.82563 11.5462C5.89523 11.4865 5.94706 11.4088 5.97545 11.3215C6.00384 11.2343 6.00769 11.141 5.98659 11.0517C5.96548 10.9624 5.92023 10.8807 5.85579 10.8154C5.79134 10.7502 5.71019 10.7039 5.6212 10.6816C4.71363 10.4547 4.13155 10.0878 3.76638 9.7819L4.28787 9.65169C4.391 9.62596 4.48324 9.56802 4.55122 9.48631C4.61919 9.40459 4.65936 9.30334 4.66589 9.19725C4.67242 9.09116 4.64497 8.98574 4.58754 8.89631C4.5301 8.80687 4.44565 8.73806 4.34646 8.69987C3.26475 8.28383 2.81052 7.69546 2.57823 7.20247C2.86089 7.26099 3.12407 7.33333 3.50011 7.33333C3.61271 7.33324 3.72199 7.29515 3.81024 7.22522C3.8985 7.15529 3.96057 7.05762 3.98641 6.94802C4.01225 6.83842 4.00033 6.72331 3.95261 6.62132C3.90488 6.51934 3.82412 6.43644 3.72341 6.38607C3.72341 6.38607 2.66677 5.9 2.66677 4.5C2.66677 4.24865 2.73639 4.08945 2.78722 3.89909C2.96161 4.13345 3.10533 4.35953 3.38683 4.61914C4.24505 5.41065 5.66356 6.21772 7.80675 6.33268C7.87456 6.3363 7.9424 6.32607 8.00614 6.30261C8.06987 6.27915 8.12815 6.24295 8.17743 6.19623C8.22672 6.1495 8.26597 6.09323 8.29279 6.03084C8.31961 5.96845 8.33344 5.90125 8.33344 5.83333V5.33333C8.33344 4.03894 9.37238 3 10.6668 3Z"
                              fill="#9EFC4E"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <p class="font-bold text-3xl mt-8">
                    {{ programArticle.title }}
                  </p>

                  <div
                    class="mt-6 font-medium text-ellipsis text-body text-brand-gray-500 whitespace-pre-wrap"
                  >
                    {{ programArticle.annotation }}
                  </div>
                </article>

<!--               <div v-if="isWorkshop && programArticle != null && userLoggedIn && workshopRegistrationOpened" class="mt-5">-->
                <div v-if="isWorkshop && programArticle != null && workshopRegistrationOpened" class="mt-5">
                  <div v-if="programArticle.capacity !== undefined && programArticle.capacity > 0" class="">
                      <div v-if="!isAlreadyRegistered() && !programArticle.userAssignedToWorkshop" class="md:flex md:items-center justify-between">
                        <button @click="registerWorkshop" class="flex justify-center md:justify-start py-3 w-full md:w-auto px-4 hover:opacity-50 transition-all duration-200 items-center bg-brand-green text-black uppercase border border-brand-green">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-4">
                            <path d="M7.99182 1.66022C7.85933 1.66229 7.73307 1.71686 7.64079 1.81195C7.5485 1.90705 7.49773 2.03488 7.49963 2.16738V7.50071H2.1663C2.10004 7.49977 2.03426 7.51202 1.97278 7.53672C1.9113 7.56143 1.85533 7.59811 1.80815 7.64463C1.76097 7.69115 1.7235 7.74659 1.69792 7.80772C1.67235 7.86885 1.65918 7.93445 1.65918 8.00071C1.65918 8.06697 1.67235 8.13258 1.69792 8.19371C1.7235 8.25483 1.76097 8.31027 1.80815 8.35679C1.85533 8.40331 1.9113 8.43999 1.97278 8.4647C2.03426 8.48941 2.10004 8.50165 2.1663 8.50071H7.49963V13.834C7.4987 13.9003 7.51094 13.9661 7.53565 14.0276C7.56035 14.0891 7.59703 14.145 7.64355 14.1922C7.69008 14.2394 7.74551 14.2768 7.80664 14.3024C7.86777 14.328 7.93337 14.3412 7.99963 14.3412C8.0659 14.3412 8.1315 14.328 8.19263 14.3024C8.25376 14.2768 8.30919 14.2394 8.35571 14.1922C8.40224 14.145 8.43892 14.0891 8.46362 14.0276C8.48833 13.9661 8.50057 13.9003 8.49963 13.834V8.50071H13.833C13.8992 8.50165 13.965 8.48941 14.0265 8.4647C14.088 8.43999 14.1439 8.40331 14.1911 8.35679C14.2383 8.31027 14.2758 8.25483 14.3013 8.19371C14.3269 8.13258 14.3401 8.06697 14.3401 8.00071C14.3401 7.93445 14.3269 7.86885 14.3013 7.80772C14.2758 7.74659 14.2383 7.69115 14.1911 7.64463C14.1439 7.59811 14.088 7.56143 14.0265 7.53672C13.965 7.51202 13.8992 7.49977 13.833 7.50071H8.49963V2.16738C8.50059 2.10046 8.48811 2.03402 8.46292 1.97202C8.43773 1.91001 8.40035 1.85369 8.353 1.80639C8.30564 1.7591 8.24927 1.72179 8.18723 1.69668C8.12519 1.67157 8.05874 1.65917 7.99182 1.66022Z" fill="black" stroke="black"/>
                          </svg>
                          Zapsat se
                        </button>
                        <p v-if="programArticle.capacity !== undefined && programArticle.capacity > 0" class="text-brand-green font-mono font-[14px] mt-4 md:mt-0">
                          Zbývá {{ programArticle.capacity }} volných míst
                        </p>
                      </div>
                      <div v-else-if="isAlreadyRegistered() && programArticle.userAssignedToWorkshop" class="md:flex md:items-center justify-between">
                        <button
                          @click="unRegisterWorkshop"
                          class="flex justify-center md:justify-start py-3 w-full md:w-auto px-4 hover:bg-[rgba(158,252,78,0.12)] transition-all duration-200 items-center bg-brand-gray-900 text-brand-green uppercase border border-brand-green"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-4">
                            <path d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H8V3.33333H3.33333V12.6667H8V14H3.33333ZM10.6667 11.3333L9.75 10.3667L11.45 8.66667H6V7.33333H11.45L9.75 5.63333L10.6667 4.66667L14 8L10.6667 11.3333Z" fill="#9EFC4E"/>
                          </svg>

                          Odhlásit se
                        </button>
                        <p v-if="programArticle.capacity !== undefined && programArticle.capacity > 0" class="text-[#81948E] font-mono font-[14px] mt-4 md:mt-0">
                          Jste zapsáni.<br>
                          Zbývá {{ programArticle.capacity }} volných míst
                        </p>
                      </div>



                  </div>
                  <div v-else>
                    <button class="cursor-not-allowed border-none flex justify-center md:justify-start py-3 w-full md:w-auto px-4 transition-all duration-200 items-center bg-white opacity-30 text-black uppercase border border-brand-green">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-4">
                        <path d="M7.99182 1.66022C7.85933 1.66229 7.73307 1.71686 7.64079 1.81195C7.5485 1.90705 7.49773 2.03488 7.49963 2.16738V7.50071H2.1663C2.10004 7.49977 2.03426 7.51202 1.97278 7.53672C1.9113 7.56143 1.85533 7.59811 1.80815 7.64463C1.76097 7.69115 1.7235 7.74659 1.69792 7.80772C1.67235 7.86885 1.65918 7.93445 1.65918 8.00071C1.65918 8.06697 1.67235 8.13258 1.69792 8.19371C1.7235 8.25483 1.76097 8.31027 1.80815 8.35679C1.85533 8.40331 1.9113 8.43999 1.97278 8.4647C2.03426 8.48941 2.10004 8.50165 2.1663 8.50071H7.49963V13.834C7.4987 13.9003 7.51094 13.9661 7.53565 14.0276C7.56035 14.0891 7.59703 14.145 7.64355 14.1922C7.69008 14.2394 7.74551 14.2768 7.80664 14.3024C7.86777 14.328 7.93337 14.3412 7.99963 14.3412C8.0659 14.3412 8.1315 14.328 8.19263 14.3024C8.25376 14.2768 8.30919 14.2394 8.35571 14.1922C8.40224 14.145 8.43892 14.0891 8.46362 14.0276C8.48833 13.9661 8.50057 13.9003 8.49963 13.834V8.50071H13.833C13.8992 8.50165 13.965 8.48941 14.0265 8.4647C14.088 8.43999 14.1439 8.40331 14.1911 8.35679C14.2383 8.31027 14.2758 8.25483 14.3013 8.19371C14.3269 8.13258 14.3401 8.06697 14.3401 8.00071C14.3401 7.93445 14.3269 7.86885 14.3013 7.80772C14.2758 7.74659 14.2383 7.69115 14.1911 7.64463C14.1439 7.59811 14.088 7.56143 14.0265 7.53672C13.965 7.51202 13.8992 7.49977 13.833 7.50071H8.49963V2.16738C8.50059 2.10046 8.48811 2.03402 8.46292 1.97202C8.43773 1.91001 8.40035 1.85369 8.353 1.80639C8.30564 1.7591 8.24927 1.72179 8.18723 1.69668C8.12519 1.67157 8.05874 1.65917 7.99182 1.66022Z" fill="black" stroke="black"/>
                      </svg>
                      Zapsat se
                    </button>
                    <p v-if="programArticle.capacity !== undefined && programArticle.capacity > 0" class="text-[#81948E] font-mono font-[14px] mt-4 md:mt-0">
                      Skupina plně obsazena
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { ExclamationIcon, XIcon } from "@heroicons/vue/outline";

export default {
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    ExclamationIcon,
    XIcon,
  },

  emits: ["close"],

  props: {
    programArticle: {
      type: Object,
    },
    isWorkshop: {
      type: Boolean,
      default: false
    },
    userLoggedIn: {
      type: Boolean,
      default: false
    },
    workshopRegistrationOpened: {
      type: Boolean,
      default: false
    },
    workshopRegistrationState: {
      type: Object,
      default: undefined,
    },
  },

  watch: {
    programArticle(newVal, oldVal) {
      if (newVal !== undefined) {
        this.open = true;
      } else {
        this.open = false;
      }
    },
  },

  data() {
    return {
      open: false,
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },

    registerWorkshop() {
      this.$emit('registerWorkshop', this.programArticle.id);
      this.close();
    },

    unRegisterWorkshop() {
      this.$emit('unRegisterWorkshop', this.programArticle.id);
      this.close();
    },

    isAlreadyRegistered() {
      return this.workshopRegistrationState.user_registrations.length > 0
    }
  },
};
</script>
